var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Error@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Toast",
    transform: "translate(-696.000000, -839.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Toast---Red",
    transform: "translate(685.000000, 822.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7789474,21.1842105 L21.8157895,17.2210526 C21.6736842,17.0789474 21.5,17 21.2947368,17 L15.6894737,17 C15.5,17 15.3105263,17.0789474 15.1842105,17.2210526 L11.2210526,21.1842105 C11.0789474,21.3263158 11,21.5 11,21.7052632 L11,27.3105263 C11,27.5 11.0789474,27.6894737 11.2210526,27.8157895 L15.1842105,31.7789474 C15.3263158,31.9210526 15.5,32 15.7052632,32 L21.3105263,32 C21.5,32 21.6894737,31.9210526 21.8315789,31.7789474 L25.7789474,27.8157895 C25.9210526,27.6736842 26,27.5 26,27.2947368 L26,21.6894737 C26,21.5 25.9210526,21.3105263 25.7789474,21.1842105 Z M21.5,26.3631579 C21.8157895,26.6789474 21.8157895,27.1842105 21.5,27.5 C21.3421053,27.6578947 21.1368421,27.7368421 20.9315789,27.7368421 C20.7263158,27.7368421 20.5210526,27.6578947 20.3631579,27.5 L18.5,25.6368421 L16.6368421,27.5 C16.4789474,27.6578947 16.2736842,27.7368421 16.0684211,27.7368421 C15.8631579,27.7368421 15.6578947,27.6578947 15.5,27.5 C15.1842105,27.1842105 15.1842105,26.6789474 15.5,26.3631579 L17.3631579,24.5 L15.5,22.6368421 C15.1842105,22.3210526 15.1842105,21.8157895 15.5,21.5 C15.8157895,21.1842105 16.3210526,21.1842105 16.6368421,21.5 L18.5,23.3631579 L20.3631579,21.5 C20.6789474,21.1842105 21.1842105,21.1842105 21.5,21.5 C21.8157895,21.8157895 21.8157895,22.3210526 21.5,22.6368421 L19.6368421,24.5 L21.5,26.3631579 Z",
    id: "Error"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.16eb987f6f97c155389b9d0ab9262f4e.svg";
export { ForwardRef as ReactComponent };